import { Component, OnInit, ViewChild } from '@angular/core';
import { PdfUtils } from 'src/app/shared/utils/pdf-utils';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
interface ProgramadoEjercidoDireccion {
  mes: string;
  modificadoRural: string;
  ejercidoRural: string;
  modificadoFederal: string;
  ejercidoFederal: string;
}
@Component({
  selector: 'modal-grafica-avance-financiero',
  templateUrl: './modal-grafica-avance-financiero.component.html',
  styleUrls: ['./modal-grafica-avance-financiero.component.scss']
})
export class ModalGraficaAvanceFinancieroComponent implements OnInit {

  @ViewChild('modalGraficaAvanceFinanciero')
  public modalGraficaAvanceFinanciero: any;
  public modalActivo: NgbModalRef;
  public datosPresupuestos: any[];
  public comentarios: { comentariosRurales: string, comentariosFederales: string };
  public programadoEjercidoDireccion: ProgramadoEjercidoDireccion[] = [];

  constructor(private modalService: NgbModal,
    private pdfUtils: PdfUtils) { }

  ngOnInit() {
  }

  public obtenerComentarios(comentarios: { comentariosRurales: string, comentariosFederales: string }) {
    this.comentarios = comentarios;
  }

  public abrirlModalGraficaAvanceFinanciero(): void {
    this.modalActivo = this.modalService.open(this.modalGraficaAvanceFinanciero, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public descargarPDF(): void {
    this.pdfUtils.descargarGraficaAvanceFinanciero(this.comentarios, this.programadoEjercidoDireccion);
  }

  public obtenerDatosCalendarioPef(programadoEjercidoDireccion: ProgramadoEjercidoDireccion[]) {
    this.programadoEjercidoDireccion = programadoEjercidoDireccion;

  }

}
